"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.erc20ContractsEmptyValuesCreator = void 0;
const viem_1 = require("viem");
const draft_js_utils_1 = require("@dzambalaorg/draft-js-utils");
const types_1 = require("../../../../types");
const baseEmptyValues = {
    title: "",
    description: draft_js_utils_1.emptyStateString,
    symbol: "",
    address: "",
    decimals: 18,
    templates: [
        {
            cap: (0, viem_1.parseEther)("1").toString(),
        },
    ],
};
const erc20ContractsEmptyValuesCreator = profile => ({
    [types_1.ServiceType.ADMIN]: {
        ...baseEmptyValues,
    },
    [types_1.ServiceType.OFFICE]: {
        ...baseEmptyValues,
        merchantId: profile.merchantId,
    },
});
exports.erc20ContractsEmptyValuesCreator = erc20ContractsEmptyValuesCreator;
//# sourceMappingURL=schemas.js.map